import { httpClient } from '@/core/api/http-client'
import type { Paged } from '@/domain/entities/paging'
import type {
  Production,
  ProductionCreateInput,
  ProductionListParams,
} from '@/domain/entities/production.entity'
import type { ProductionRepository } from '@/domain/repositories/production.repository'
import { unwrap, unwrapPaged } from '@/infrastructure/shared/unwrap'
import type { ProductionDto } from './production.dto'
import { productionMapper } from './production.mapper'

export class ProductionHttpRepository implements ProductionRepository {
  async list(outletId: string, params: ProductionListParams): Promise<Paged<Production>> {
    const raw = await httpClient.get<unknown>('/productions', {
      params: {
        outlet_id: outletId,
        page: params.page,
        limit: params.limit,
        from: params.from,
        to: params.to,
      },
    })
    const paged = unwrapPaged<ProductionDto>(raw, params.page, params.limit)
    return { ...paged, items: paged.items.map(productionMapper.toProduction) }
  }

  async getById(id: string): Promise<Production> {
    const raw = await httpClient.get<unknown>(`/productions/${id}`)
    return productionMapper.toProduction(unwrap<ProductionDto>(raw))
  }

  async create(outletId: string, input: ProductionCreateInput): Promise<Production> {
    const raw = await httpClient.post<unknown>('/productions', {
      outlet_id: outletId,
      recipe_id: input.recipeId,
      batch_qty: String(input.batchQty),
      note: input.note ?? '',
    })
    return productionMapper.toProduction(unwrap<ProductionDto>(raw))
  }
}
